/** Shared with legacy Automation Studio — tracks last route on unmount for re-entry reset. */
export const AUTOMATION_STUDIO_LAST_ROUTE_KEY = 'automation_studio_last_route';

let preserveSessionOnNextRouteEffect = false;

/** Skip the next route-session reset (e.g. after save navigates to a new test case URL). */
export function markAutomationStudioSessionPreserved() {
    preserveSessionOnNextRouteEffect = true;
}

export function consumeAutomationStudioSessionPreserve() {
    const preserve = preserveSessionOnNextRouteEffect;
    preserveSessionOnNextRouteEffect = false;
    return preserve;
}

export function readAutomationStudioLastRoute() {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage.getItem(AUTOMATION_STUDIO_LAST_ROUTE_KEY);
}

export function writeAutomationStudioLastRoute(pathname) {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.setItem(AUTOMATION_STUDIO_LAST_ROUTE_KEY, pathname || '');
}

/**
 * Returns true when Redux should reset because the user returned from another page
 * or the automation-studio URL changed since the last recorded route.
 */
export function shouldResetAutomationStudioOnRouteChange(lastRoute, currentPath, { preserveSession = false } = {}) {
    if (preserveSession) return false;
    if (lastRoute == null || lastRoute === '') return false;
    if (!currentPath) return false;
    return lastRoute !== currentPath;
}
